import React from 'react';
import { LayoutPage } from 'components/layouts';
import { Divider } from 'antd';
import './style.css';

const TermsWorker = () => {
  return (
    <LayoutPage>
      <LayoutPage.Content className="container">
        <div className="content">
          <h1>Terms and Conditions - Workers</h1>
          <p>
            <strong>
              PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE
              REGISTERING FOR AN ACCOUNT WITH MYSHIFTS LIMITED
            </strong>
          </p>
          <p>
            These are the terms and conditions (together with our Privacy Policy
            and Terms of Website Use) (<strong>Terms</strong>) which will apply
            to the operation of your MyShifts Account. Please read these Terms
            carefully and make sure that you understand them.
          </p>
          <p>
            We amend these Terms from time to time. Please check these Terms
            frequently to ensure you understand the Terms that apply at that
            time. These Terms were most recently updated on 22<sup>nd</sup>
            March 2021.
          </p>

          <Divider />

          <h3>1. Definitions</h3>
          <p>
            <strong>Care Providers</strong>: any person or company who seeks
            Workers via our website.
          </p>
          <p>
            <strong>Shift</strong>: the work shift that a Care Provider would
            like to complete out by a Worker (and <strong>Shifts </strong>shall
            be construed accordingly).
          </p>
          <p>
            <strong>MyShifts Account</strong>: the online account you register
            with us, with which you use to sign into our website.
          </p>
          <p>
            <strong>Workers</strong>: Health and Social Care Workers who have
            signed up for a MyShifts Account.
          </p>

          <Divider />

          <h3>2. Information about us and how to contact us</h3>
          <ol>
            <li>
              We operate the website My-Shifts.com (“
              <strong>our website</strong>”). We are My Shifts Limited a company
              registered in England and Wales under company number 10967405 and
              with our registered office at Optima House, 100 Manchester Road,
              Denton, Manchester, United Kingdom, M34 3PR.
            </li>
            <li>
              You can contact us by writing to us at
              <a href="mailto:hello@my-shifts.co.uk">hello@my-shifts.co.uk</a>.
            </li>
            <li>
              If we have to contact you, we will do so by telephone or by
              writing to you at the email address or postal address you provided
              to us when opening your MyShifts Account.
            </li>
            <li>
              "Writing" includes emails. When we use the words "writing" or
              "written" in these terms, this includes emails.
            </li>
          </ol>

          <Divider />

          <h3>3. Your MyShifts Account and password</h3>
          <ol>
            <li>
              In order to open a MyShifts Account, you will be required to
              provide us with certain details, including the following:
              <ol>
                <li>
                  your full contact details, including telephone number, email
                  address and postal address;
                </li>
                <li>
                  details of the health and/or social care services you supply;
                </li>
                <li>
                  if the health and/or social care services you supply require
                  certain qualifications, membership or certifications, you must
                  supply us with proof of such;
                </li>
                <li>your hourly pay rate; and</li>
                <li>
                  your Shift availability and minimum notice of Shift
                  requirements.
                </li>
              </ol>
            </li>
            <li>
              If you do not provide us with this information, you will not be
              permitted to open a MyShifts Account with us.
            </li>
            <li>
              You must ensure that the information provided to us, under clause
              3.1 is true, accurate and up to date at all times.
            </li>
            <li>
              If you choose, or you are provided with, a user identification
              code, password or any other piece of information as part of our
              security procedures, you must treat such information as
              confidential. You must not disclose it to any third party.
            </li>
            <li>
              If you know or suspect that anyone other than you knows your user
              identification code or password, you must promptly notify us by
              emailing us at
              <a href="mailto:hello@my-shifts.co.uk">hello@my-shifts.co.uk</a>
              and writing SECURITY in the subject line.
            </li>
            <li>
              You can close your MyShifts Account at any time by emailing us at
              hello@my-shifts.co.uk.
            </li>
            <li>
              We may at our discretion close your MyShifts Account if it has
              been inactive for 12 months or more.
            </li>
            <li>
              We may disable or close (at our discretion) your MyShifts Account
              at any time by giving [two weeks’ notice to you] or with immediate
              effect if, in our reasonable opinion, you have failed to comply
              with any of the provisions of these Terms, or if we receive any
              complaint about you.
            </li>
          </ol>

          <Divider />

          <h3>4. Applying for Shifts</h3>
          <ol style={{ counterReset: 'lis 8' }}>
            <li>
              Care Providers (Employers as we call them) use our website to post
              details of Shifts.
            </li>
            <li>
              We will send anonymised details of
              Workers to the Employers who we believe (based on the information
              you provide to us) are going to be available and suited to the
              relevant Shift.
            </li>
            <li>
              If an Employer wishes to ‘connect’ with you, we will contact you
              [by email/text] to confirm your availability. Only when you have
              confirmed your availability will we release your full details to
              the Employer.
            </li>
            <li>
              It is your responsibility to verify all details directly with the
              Employer if you are successfully allocated a Shift.
            </li>
            <li>
              We are not a recruitment agency and we do not offer any guarantee
              that a connection with an Employer will result in any Shifts being
              provided to you.
            </li>
          </ol>

          <Divider />

          <h3>5. How we use your personal information</h3>
          <p>
            We only use your personal information in accordance with our Privacy
            Policy. Please take the time to read our Privacy Policy as it
            includes important terms which apply to you.
          </p>

          <Divider />

          <h3>6. Our liability </h3>
          <ol style={{ counterReset: 'lis 13' }}>
            <li>
              We are responsible to you for foreseeable loss and damage caused
              by us. If we fail to comply with these terms, we are responsible
              for loss or damage you suffer that is a foreseeable result of our
              breaking this contract or our failing to use reasonable care and
              skill, but we are not responsible for any loss or damage that is
              not foreseeable.
            </li>
            <li>
              We do not exclude or limit in any way our liability to you, where
              it would be unlawful to do so. This includes liability for death
              or personal injury caused by our negligence or the negligence of
              our employees, agents or subcontractors or for fraud or fraudulent
              misrepresentation.
            </li>
            <li>
              We will not be liable for damages to a device or digital content
              belonging to you caused by defective digital content we supplied
              to you or your use of our website which you could have avoided by
              following our advice to apply an update offered to you free of
              charge or for damage which was caused by you failing to correctly
              follow installation instructions or to have in place the minimum
              system requirements advised by us.
            </li>
            <li>
              We are not liable for business losses. If you use a MyShifts
              Account for any commercial, business or subcontracting purpose we
              will have no liability to you for any loss of profit, loss of
              business, business interruption, or loss of business opportunity.
            </li>
          </ol>

          <Divider />

          <h3>7. Other important terms</h3>
          <ol style={{ counterReset: 'lis 17' }}>
            <li>
              We may transfer our rights and obligations under these Terms to
              another organisation. We will always tell you in writing if this
              happens.
            </li>
            <li>
              You may only transfer your rights or your obligations under these
              Terms to another person if we agree to this in writing.
            </li>
            <li>
              This Contract is between you and us. No other person shall have
              any rights to enforce any of its terms, whether under the
              Contracts (Rights of Third Parties) Act 1999 or otherwise.
            </li>
            <li>
              Each of the paragraphs of these Terms operates separately. If any
              court or relevant authority decides that any of them are unlawful
              or unenforceable, the remaining paragraphs will remain in full
              force and effect.
            </li>
            <li>
              If we fail to insist that you perform any of your obligations
              under these Terms, or if we do not enforce our rights against you,
              or if we delay in doing so, that will not mean that we have waived
              our rights against you and will not mean that you do not have to
              comply with those obligations. If we do waive a default by you, we
              will only do so in writing, and that will not mean that we will
              automatically waive any later default by you.
            </li>
            <li>
              These terms are governed by English law and you can bring legal
              proceedings in the English courts. If you live in Scotland you can
              bring legal proceedings in either the Scottish or the English
              courts. If you live in Northern Ireland you can bring legal
              proceedings in either the Northern Irish or the English courts.
            </li>
          </ol>
        </div>
      </LayoutPage.Content>
    </LayoutPage>
  );
};

export default TermsWorker;
